<template>
  <div class="container">
    <van-list>
      <van-cell>
        <template slot="default">
          <div class="header-warp">
            <h4>产品品号：{{ erpVendorIntransitOrders.productId }}</h4>
            <p>产品品名：{{ erpVendorIntransitOrders.productName }}</p>
          </div>
        </template>
      </van-cell>
      <van-cell>
        <template slot="default">
          <div class="detail-wrap">
            <div class="item">
              <p>合同号：{{ erpVendorIntransitOrders.contractNumber }}</p>
              <p>应交数量：{{ erpVendorIntransitOrders.quantityPurchased }}</p>
              <p>已交数量：{{ erpVendorIntransitOrders.quantityDelivered }}</p>
              <p>
                预到货日：{{ erpVendorIntransitOrders.expectedArrivalTime }}
              </p>
              <p>供应商反馈：{{ erpVendorIntransitOrders.supplierRemark }}</p>
              <p>
                备注：<input
                  type="text"
                  v-model="erpVendorIntransitOrders.remark"
                  placeholder="请输入备注"
                />
              </p>
              <p>
                是否隐藏：
                <input type="checkbox" v-model="isDeletedCheckbox" />
              </p>
            </div>
          </div>
        </template>
      </van-cell>

      <!-- 标签选择区域 -->
      <van-cell>
        <template slot="default">
          <div class="tags-wrap">
            <h4>请选择标签：</h4>
            <van-checkbox-group v-model="selectedLableIds">
              <van-checkbox
                v-for="lable in lablsList"
                :key="lable.id"
                :name="lable.id"
              >
                {{ lable.name }}
              </van-checkbox>
            </van-checkbox-group>
          </div>
        </template>
      </van-cell>
    </van-list>

    <div class="footer">
      <button class="save-button" @click="updateData">保存</button>
    </div>
  </div>
</template>

<script>
import api from '@/api/erpVendorIntransitOrders'
export default {
  name: 'process',

  props: {
    msg: String,
  },

  data() {
    return {
      // 产品id
      id: 0,
      // 商品详细详细
      erpVendorIntransitOrders: {},
      // 标签列表
      lablsList: [],

      // 选中的标签 ID
      selectedLableIds: [], // 用于绑定多选
    }
  },

  created() {
    this.id = this.$route.params.id
    this.fetchData(this.id)
    this.fetchLableList() // 获取标签列表
  },
  computed: {
    // 计算属性，将 isDeleted 转换为布尔值
    isDeletedCheckbox: {
      get() {
        return this.erpVendorIntransitOrders.isDeleted === 1 // 如果是 1，复选框选中
      },
      set(value) {
        this.erpVendorIntransitOrders.isDeleted = value ? 1 : 0 // 如果选中，则设置为 1，否则为 0
      },
    },
  },

  methods: {
    // 查询单条详细信息
    fetchData(id) {
      api.show(id).then((response) => {
        this.erpVendorIntransitOrders = response.data
        this.selectedLableIds = response.data.lableIdList
      })
    },

    // 获取标签列表
    fetchLableList() {
      api.selectAllLables().then((response) => {
        this.lablsList = response.data
      })
    },

    // 给订单修改数据
    updateData() {
      let orderVo = {
        purchaseOrderId: this.erpVendorIntransitOrders.purchaseOrderId,
        productId: this.erpVendorIntransitOrders.productId,
        quantityPurchased: this.erpVendorIntransitOrders.quantityPurchased,
        contractNumber: this.erpVendorIntransitOrders.contractNumber,
        remark: this.erpVendorIntransitOrders.remark,
        isDeleted: this.erpVendorIntransitOrders.isDeleted,
        lable: (this.selectedLableIds || []).join(','), // 将选中的标签 ID 转换为逗号分隔的字符
      }
      api
        .updateData(orderVo)
        .then((response) => {
          // 添加成功后显示提示
          this.$toast.success('添加成功！')
          // 通知父页面刷新
          const page = this.$route.query.page || 1 // 假设当前页码从路由传递
          window.parent.postMessage({ action: 'onLoad', page }, '*') // 发送当前页码
        })
        .catch((error) => {
          // 添加失败时提示错误信息
          this.$toast.fail('添加失败，请重试！')
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-bottom: 86px;
  .header-warp {
    position: relative;
    h4 {
      font-size: 16px;
      margin: 5px;
    }
    p {
      font-size: 16px;
      margin: 5px;
    }
    .pass {
      color: #4cb971;
      margin: 5px;
    }
    .refused {
      color: #eb8473;
      margin: 5px;
    }
  }
  .detail-wrap {
    .item {
      h5 {
        color: #838485;
        margin: 5px;
      }
      p {
        color: #1b1f22;
        font-size: 16px;
        margin: 5px;
      }
    }
  }
  .result {
    font-size: 14px;
    h4,
    p {
      margin: 5px;
      font-size: 14px;
    }
  }
  .seal-wrap {
    position: absolute;
    top: 20px;
    right: 30px;
  }

  .notice {
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 12px;
    padding: 8px 10px;
    background: #fefbe8;
    position: fixed;
    bottom: 53px;
    z-index: 10;
    p {
      flex: 1;
      margin: 4px;
    }
    .pass {
      color: #07c160;
      margin-right: 20px;
    }
  }
  .footer {
    // height: 50px;
    padding: 10px;
    background: #f8f8f8;
    display: flex;
    align-items: center;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 10;

    .save-button {
      flex: 1; /* 占据剩余空间 */
      padding: 10px 20px; /* 内边距 */
      background-color: #007bff; /* 蓝色背景 */
      color: #fff; /* 白色文字 */
      border: none; /* 去掉默认边框 */
      border-radius: 4px; /* 圆角边框 */
      font-size: 16px; /* 字体大小 */
      text-align: center; /* 居中对齐 */
      cursor: pointer; /* 鼠标指针 */
      transition: background-color 0.3s, box-shadow 0.3s; /* 动效 */
    }

    .save-button:hover {
      background-color: #0056b3; /* 悬停时的背景颜色 */
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* 悬停时的阴影效果 */
    }

    .save-button:active {
      background-color: #003d80; /* 按下时的背景颜色 */
      box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2); /* 按下时的内嵌阴影 */
    }
  }
}

/deep/ .van-cell {
  position: inherit;
  overflow: visible;
}

/deep/ .van-cell__value {
  position: inherit;
  overflow: visible;
}
</style>
